import _sfc_main from './src/popconfirm.vue2.mjs';
export { popconfirmEmits, popconfirmProps } from './src/popconfirm.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElPopconfirm = withInstall(_sfc_main);

export { ElPopconfirm, ElPopconfirm as default };
//# sourceMappingURL=index.mjs.map
